import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {SessionService} from '../Services/Session/session-service.service';

@Component({
  selector: 'app-wait-list',
  templateUrl: './wait-list.component.html',
  styleUrls: ['./wait-list.component.css']
})
export class WaitListComponent implements OnInit {
  env = environment;
  constructor(private router: Router, private session: SessionService) { }

  ngOnInit(): void {
    try {
      this.env.showSteps = true;
      this.env.activeIndex = 3;
      this.env.selectedProvider = JSON.parse(this.session.getParam('selectedProvider'));
      this.env.showSteps = JSON.parse(this.session.getParam('showSteps'));
    } catch (e) {
      this.env.showSteps = false;
      this.router.navigate(['home/providers']);
    }
    this.env.showSteps = true;
    this.env.activeIndex = 3;
  }

}
